import styled from "@emotion/styled";
import { colors, colorsRGB } from "styles/colors";
import { fonts } from "styles/fonts";

export const Title = styled.div`
  color: ${colors.WHITE};
  font-size: 14px;
  line-height: 30px;
  font-family: ${fonts.latoBold};
`;

export const IconWrap = styled.div`
  cursor: pointer;
  .icon {
    stroke: ${colors.WHITE};
    fill: ${colors.WHITE};
    width: 12px;
    height: 12px;
  }
`;

export const TitleWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Video = styled.video`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: cover;
  object-position: center;
`;

export const CustomButton = styled.div`
  border: 1px solid ${colors.WHITE};
  background: transparent;
  color: ${colors.WHITE};
  border-radius: 5px;
  padding: 10px 28px 10px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  #replay {
    margin-left: 10px;
  }
`;

export const BtnsWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 90vw;
  padding: 0px;
  border-radius: 20px;
  margin: 0 auto;
`;

export const ModalWrap = styled.div`
  position: relative;
  min-height: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(${colorsRGB.GREY_DARK}, 0.9);
`;

export const CreatorVideoModalContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1000;
  top: 0;
`;
